/**
 * This is import script.js file
 */
import ActionsDetail from '@/components/actions-detail';
import UploadDetail from '../upload-detail';
import YuriModal from '@/components/yuri-modal';

export default  {
    name: 'ImportedModal',
    extends: YuriModal,
    components: {
        ActionsDetail,
        UploadDetail
    },
    /**
     * @override
     */
    data() {
        return {
            selected: null
        };
    },

    props: {
        modalId: {
            type: String,
            required: true
        },
        uuid: {
            type: String,
            required: false
        },
        uploads: {
            type: Array,
            required: false
        },
        status: {
            type: String,
            required: false
        },
        filename: {
            type: String,
            required: false
        },
        created_on: {
            type: String,
            required: false
        },
        filetype: {
            type: String,
            required: false
        },
        filerecords: {
            type: Number,
            required: false
        },
        errors: {
            type: Number,
            required: false
        },
        filesize: {
            type: Number,
            required: false
        }
    },
    watch: {
        uuid(n) {
            this.selected = n;
        }
    },
    methods: {
        /**
         * @override
         */
        hideDetails() {
            this.showingDetail = [];
            this.$bvModal.hide(this.modalId);
        },
        /**
         * @override
         */
        fileIconClass(result) {
            let i = 'fa-file';
            switch (result) {
                case 'success':
                    i = 'fa-file-check color-brand';
                    break;
                case 'warn':
                    i = 'fa-file-exclamation color-pending';
                    break;
                case 'error':
                    i = 'fa-file-times color-error';
                    break;
                default:
                    i = 'fa-file';
            }
            return i;
        }
    },
    computed: {
        files () {
            return this.uploads ?
                this.uploads.slice(0, 7).map(x => {
                    x.ok = x.summary ? x.summary.filter(s => s.result === 'SUCCESS').length : 0;
                    x.ko = x.summary ? x.summary.filter(s => !s.result !== 'SUCCESS').length : 0;
                    x.total = x.summary ? x.summary.length : 0;
                    x.result = x.ok < 1
                        ? 'error'
                        : x.ok < x.total
                            ? 'warn'
                            : 'success';
                    return x;
                })
                : [];
        }
    }

};
